if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
function mediaSilder(){
  // $('.product__media-list').slick('unslick');
  $('.product__media-list').slick({
      arrows: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ]
    });
}
$(document).ready(function(){
  $(document).on('click','.swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    // $(this).parents('.swatches-block').find('.option_label').text(OptionName);
    $(this).parents('.swatches-block').find('select').val(OptionName).change();

    // Update the select element
    var $select = $(this).parents('.product-form__input--dropdown').find('.old_selector select');
    $select.val(OptionName);

    // Manually dispatch the change event
    var event = new Event('change', {
        bubbles: true,
        cancelable: true
    });
    $select[0].dispatchEvent(event);
  })

  $(document).on('change','.swatches-block select', function () {
    var FinalValue = '';
    var thisParentId = $(this).parents('.product-form__input').attr('data-id');
    //console.log('thisParentId::'+thisParentId);
    $('.product-form__input[data-id="'+thisParentId+'"] .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
      //console.log('selectVal::'+selectVal);
    });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
      //console.log('newstr::'+newstr);
 
    
    var optionName_Selector = $('.product-form__input[data-id="'+thisParentId+'"] select.product_card-form__master-select option[check-data-sku="'+newstr+'"]')
     var optionName_val = optionName_Selector.val();
    $('.product-form__input[data-id="'+thisParentId+'"] select.product_card-form__master-select').val(optionName_val).change();
 
    })

    $(document).on('change','select.product_card-form__master-select', function () {
        var thisMainVal = $(this).val(); 
        var thisParentId = $(this).parents('.product-form__input').attr('data-id');
        console.log('thisMainVal::'+thisMainVal);
        // console.log('thisParentId::'+thisParentId);
        // var thiSubType = $('.product-form__input[data-id="'+thisParentId+'"] .cdk--custom_subscription_options .subscription_pan_item.active').attr('data-type');
        // console.log('thiSubType::'+thiSubType);
        // var ThisSellingPlan = $('.product-form__input[data-id="'+thisParentId+'"] .cdk_prod_selling_palns').val();
        // console.log('ThisSellingPlan::'+ThisSellingPlan);
        var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
        // console.log('ThisProdAvail::'+ThisProdAvail);
       
        // $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-variant', thisMainVal).attr('data-sellingplan',ThisSellingPlan);
      $('.product-variant-id').attr('value',thisMainVal);
      $('.swatches-block').addClass('option-selected');
        if (ThisProdAvail == 'true'){
          $('.product-form-wrapper .product-form__submit').find('.btn__text').text('Add to cart');
          $('.product-form-wrapper .product-form__submit').attr('disabled', false);
          $('.product-form-wrapper .product-form__submit').removeClass('soldout');
          $('.product-form-wrapper .product-form__submit').removeClass('disabled');
        }else{
          $('.product-form-wrapper .product-form__submit').find('.btn__text').text('Out of stock');
          $('.product-form-wrapper .product-form__submit').attr('disabled', true);
          $('.product-form-wrapper .product-form__submit').addClass('soldout');
          $('.product-form-wrapper .product-form__submit').addClass('disabled');
        } 
      })
  $(document).on('click', '.swatches-block',function(ee){
    ee.preventDefault();
    console.log('click');
    // $(this).toggleClass('open');
    // $(this).find('.swatches-block-box').slideToggle();
  })
  $('.tab-nav .tab').click(function(){
    $('.tab-nav .tab').removeClass('active');
    $(this).addClass('active');
    var t = $(this).attr('data-tab');
  
    $('.tab_content').hide();
    $('#pro_'+ t).fadeIn('show');
   
  });
  mediaSilder();
   $(window).on('resize', function() {
        // Call the handleResize function after a short delay to prevent excessive calls
        clearTimeout($.data(this, 'resizeTimer'));
        $.data(this, 'resizeTimer', setTimeout(function() {
            mediaSilder();
        }, 200));
    }); 


})
